"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _autobahnUtilities = require("@gcc/autobahn-utilities");

var _axios = _interopRequireDefault(require("axios"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _propTypes = require("prop-types");

var _psl = _interopRequireDefault(require("psl"));

var _react = _interopRequireDefault(require("react"));

var _InternalUserHeader = require("./InternalUserHeader.styles");

var InternalUserHeader = function InternalUserHeader(_ref) {
  var _theme$internalUser2;

  var headerSpaceClassName = _ref.headerSpaceClassName,
      showEmptyCartLink = _ref.showEmptyCartLink,
      baseUrl = _ref.baseUrl,
      theme = _ref.theme;

  var handleEmptyCart = function handleEmptyCart(autobahnUrl) {
    _axios["default"].post("".concat(autobahnUrl, "/Cart/Empty")).then(function (response) {
      if (response) window.location.reload();
    });
  };

  var handleLogout = function handleLogout(autobahnUrl) {
    var _theme$internalUser;

    if (theme !== null && theme !== void 0 && (_theme$internalUser = theme.internalUser) !== null && _theme$internalUser !== void 0 && _theme$internalUser.clearCookiesClientSide) {
      var parsed = _psl["default"].parse(window.location.hostname);

      var rootDomain = ".".concat(parsed.domain);

      _jsCookie["default"].remove('internalUser', {
        path: '/',
        domain: rootDomain
      });

      _jsCookie["default"].remove('CartOnBehalfOf', {
        path: '/',
        domain: rootDomain
      });

      _jsCookie["default"].remove('dateAsOf', {
        path: '/',
        domain: rootDomain
      });

      window.location.reload();
    } else {
      _axios["default"].get("".concat(autobahnUrl, "/InternalUser/LogoutAndRemoveCookie")).then(function (response) {
        if (response) window.location.reload();
      });
    }
  };

  var headerSpacer = document.getElementsByClassName(headerSpaceClassName)[0];
  if (headerSpacer) headerSpacer.style.display = 'block';

  if (!showEmptyCartLink) {
    document.querySelector('body').classList.add('is-internal-user');
  }

  var userName = (0, _autobahnUtilities.userNameWithoutDomainPrefix)();

  if (!userName) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_InternalUserHeader.StyledInternalUserHeader, {
    id: "internal-user-sticky"
  }, (theme === null || theme === void 0 ? void 0 : (_theme$internalUser2 = theme.internalUser) === null || _theme$internalUser2 === void 0 ? void 0 : _theme$internalUser2.addSpaceForInternalUserHeader) && /*#__PURE__*/_react["default"].createElement(_InternalUserHeader.StyledInternalUserGlobalStyle, null), /*#__PURE__*/_react["default"].createElement(_InternalUserHeader.StyledInternalUserContainer, null, /*#__PURE__*/_react["default"].createElement(_InternalUserHeader.StyledInternalUserItemContainer, null, /*#__PURE__*/_react["default"].createElement(_InternalUserHeader.StyledInternalUserTitle, null, "Logged in as"), /*#__PURE__*/_react["default"].createElement(_InternalUserHeader.StyledInternalUserName, {
    className: "sticky-item-value"
  }, userName)), /*#__PURE__*/_react["default"].createElement(_InternalUserHeader.StyledInternalUserItemContainer, null, showEmptyCartLink ? /*#__PURE__*/_react["default"].createElement(_InternalUserHeader.StyledInternalUserLink, {
    href: "",
    onClick: function onClick() {
      return handleEmptyCart(baseUrl);
    },
    title: "Empty the cart. (You will stay logged in.)"
  }, "Empty Cart") : null, /*#__PURE__*/_react["default"].createElement(_InternalUserHeader.StyledInternalUserLink, {
    href: "#",
    onClick: function onClick() {
      return handleLogout(baseUrl);
    },
    title: "Stop browsing the site as an internal user. (This leaves the cart unchanged.)"
  }, "Logout"))));
};

InternalUserHeader.defaultProps = {
  headerSpaceClassName: 'bdc-header-spacer-for-stickies',
  baseUrl: '',
  showEmptyCartLink: true,
  theme: (0, _propTypes.shape)({})
};
InternalUserHeader.propTypes = {
  headerSpaceClassName: _propTypes.string,
  showEmptyCartLink: _propTypes.bool,
  baseUrl: _propTypes.string,
  theme: {}
};
InternalUserHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InternalUserHeader",
  "props": {
    "headerSpaceClassName": {
      "defaultValue": {
        "value": "'bdc-header-spacer-for-stickies'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "baseUrl": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "showEmptyCartLink": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "theme": {
      "defaultValue": {
        "value": "shape({})",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "custom",
        "raw": "{}"
      },
      "required": false
    }
  }
};
var _default = InternalUserHeader;
exports["default"] = _default;